import React from 'react';

import { CFColorTokenProp } from '../../../theme/tokens/contentful-color';

import { Flexbox } from '../../Flexbox';

import { WidgetProps, DEFAULT_BUTTON_TEXT, SharedProps } from '../shared';

import { Button } from './styles';

export function StandardWidget({
  buttonColor = 'ginger',
  buttonHoverColor = 'green',
  buttonText = DEFAULT_BUTTON_TEXT,
  buttonContent
}: WidgetProps & SharedProps) {
  return (
    <Flexbox>
      <Button
        type="submit"
        role="link"
        cfButtonColor={buttonColor as CFColorTokenProp}
        cfButtonHoverColor={buttonHoverColor as CFColorTokenProp}
        aria-label={buttonText as string}
        data-testid="standard-cta-btn"
      >
        {buttonContent || buttonText}
      </Button>
    </Flexbox>
  );
}
